var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 82,
    viewBox: "0 0 140 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 137,
    height: 79,
    rx: 3.5,
    fill: "#AFDB28",
    fillOpacity: 0.2,
    stroke: "#22A156",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.53 8.46967C127.237 8.17678 126.763 8.17678 126.47 8.46967L121.697 13.2426C121.404 13.5355 121.404 14.0104 121.697 14.3033C121.99 14.5962 122.464 14.5962 122.757 14.3033L127 10.0607L131.243 14.3033C131.536 14.5962 132.01 14.5962 132.303 14.3033C132.596 14.0104 132.596 13.5355 132.303 13.2426L127.53 8.46967ZM126.47 73.5303C126.763 73.8232 127.237 73.8232 127.53 73.5303L132.303 68.7574C132.596 68.4645 132.596 67.9896 132.303 67.6967C132.01 67.4038 131.536 67.4038 131.243 67.6967L127 71.9393L122.757 67.6967C122.464 67.4038 121.99 67.4038 121.697 67.6967C121.404 67.9896 121.404 68.4645 121.697 68.7574L126.47 73.5303ZM126.25 9L126.25 73L127.75 73L127.75 9L126.25 9Z",
    fill: "#22A156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.435 48V33.4545H115.003C116.054 33.4545 116.928 33.6203 117.624 33.9517C118.324 34.2784 118.848 34.7259 119.193 35.294C119.544 35.8622 119.719 36.5062 119.719 37.2259C119.719 37.8177 119.605 38.3243 119.378 38.7457C119.151 39.1624 118.845 39.5009 118.462 39.7614C118.078 40.0218 117.65 40.2088 117.176 40.3224V40.4645C117.692 40.4929 118.187 40.6515 118.661 40.9403C119.139 41.2244 119.529 41.6269 119.832 42.1477C120.135 42.6686 120.287 43.2983 120.287 44.0369C120.287 44.7898 120.105 45.4669 119.74 46.0682C119.375 46.6648 118.826 47.1359 118.092 47.4815C117.358 47.8272 116.435 48 115.322 48H109.435ZM112.07 45.7983H114.903C115.86 45.7983 116.549 45.616 116.97 45.2514C117.396 44.8821 117.609 44.4086 117.609 43.831C117.609 43.4001 117.503 43.0118 117.29 42.6662C117.077 42.3158 116.774 42.0412 116.381 41.8423C115.988 41.6387 115.519 41.5369 114.974 41.5369H112.07V45.7983ZM112.07 39.6406H114.676C115.131 39.6406 115.54 39.5578 115.905 39.392C116.269 39.2216 116.556 38.9825 116.764 38.6747C116.977 38.3622 117.084 37.9929 117.084 37.5668C117.084 37.0033 116.885 36.5393 116.487 36.1747C116.094 35.8101 115.509 35.6278 114.733 35.6278H112.07V39.6406Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRb);
export default __webpack_public_path__ + "static/media/rb.e89d4d770dd688e2db2622718a9f5cc8.svg";
export { ForwardRef as ReactComponent };